import React, { useEffect, useState } from "react";

import { Button, Modal, Spin } from "antd";

import { GYNGER_CHECKOUT_PENDING_MESSAGE } from "../hooks/useGyngerCheckoutPayment";

import "./CheckoutProcessingOverlay.css";

export default function CheckoutProcessingOverlay({
  open = false,
  message = GYNGER_CHECKOUT_PENDING_MESSAGE,
  onCancelPayment,
  paymentUrl,
  contained = false,
}) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      setConfirmOpen(false);
    }
  }, [open]);

  const handleConfirmCancelPayment = () => {
    setConfirmOpen(false);
    if (onCancelPayment) {
      onCancelPayment();
    }
  };

  if (!open) {
    return null;
  }

  return (
    <>
      <div
        className={`CheckoutProcessingOverlay${contained ? " CheckoutProcessingOverlay--contained" : ""}`}
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <Spin size="large" />
        <p className="CheckoutProcessingOverlay__Message">{message}</p>
        {paymentUrl && (
          <a
            href={paymentUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="CheckoutProcessingOverlay__PaymentLink"
          >
            Payment tab didn&apos;t open? Open payment page
          </a>
        )}
        {onCancelPayment && (
          <Button
            type="default"
            size="small"
            onClick={() => setConfirmOpen(true)}
          >
            Cancel Payment
          </Button>
        )}
      </div>

      <Modal
        open={confirmOpen}
        centered
        destroyOnHidden
        maskClosable={false}
        closable={false}
        keyboard={false}
        width={424}
        zIndex={1100}
        title="Cancel payment?"
        okText="Yes"
        cancelText="No"
        onOk={handleConfirmCancelPayment}
        onCancel={() => setConfirmOpen(false)}
      >
        <p className="CheckoutProcessingOverlay__ConfirmCopy">
          Stop waiting for this payment? You can stay on this screen and try again.
        </p>
      </Modal>
    </>
  );
}
